
import { Component, Vue, Prop } from "vue-property-decorator";
import { SMDocuments } from "@/store";
import { API_TCheck } from "@/models/document_checks";

@Component({
  components: {
    ActionContainerCard: () => import("@/components/ActionContainer/ActionContainerCard.vue"),
  },
})
export default class DocumentCardChecks extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly checks!: API_TCheck[];
  @Prop({ type: Boolean, default: false }) readonly error?: boolean;
  @Prop({ type: Boolean, default: false }) readonly canUploadFile?: boolean;

  get selectedChecks() {
    return SMDocuments.selectedChecks;
  }

  getOptionsFromCheck(check: API_TCheck) {
    return check.options.split(",,").map((value) => {
      const obj = { value, label: value, disabled: false };

      if (!this.canUploadFile) obj["disabled"] = true;

      return obj;
    });
  }

  onCheckSelect(id: number, value: string) {
    SMDocuments.selectCheck({ id, value });
    SMDocuments.updateChecks();
  }
}
